var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.299805 8.4498C0.299805 7.70422 0.90422 7.0998 1.6498 7.0998C2.39539 7.0998 2.9998 7.70422 2.9998 8.4498V13.8498C2.9998 14.5954 2.39539 15.1998 1.6498 15.1998C0.90422 15.1998 0.299805 14.5954 0.299805 13.8498V8.4498Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8998 8.29981V13.1873C3.8998 13.8691 4.28501 14.4924 4.89482 14.7973L4.93968 14.8197C5.43956 15.0697 5.99077 15.1998 6.54965 15.1998H11.4242C12.2822 15.1998 13.0209 14.5942 13.1892 13.7528L14.2692 8.35282C14.492 7.23899 13.64 6.1998 12.5042 6.1998H9.2998V2.5998C9.2998 1.60569 8.49392 0.799805 7.4998 0.799805C7.00275 0.799805 6.5998 1.20275 6.5998 1.6998V2.2998C6.5998 3.07874 6.34716 3.83666 5.8798 4.4598L4.6198 6.1398C4.15245 6.76295 3.8998 7.52087 3.8998 8.29981Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.8c0705256f85c60a3d6f2c4bb652b190.svg";
export { ForwardRef as ReactComponent };